export type BillingsOrderRailyTaxiCreateRequestBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate?: Date;
  checkoutEventId?: string;
  plannedDate?: Date;
  orderId?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export enum BillingsOrderRailyTaxiCreateRequestPenaltyType {
  OPTIMIZATION_REFUSED = "OPTIMIZATION_REFUSED",
  BEING_LATE = "BEING_LATE",
  INCOMPATIBLE_CAR = "INCOMPATIBLE_CAR",
  HIGHWAY_NOT_ALLOWED = "HIGHWAY_NOT_ALLOWED",
  SUBOPTIMAL_RIDE = "SUBOPTIMAL_RIDE",
  GUIDELINE_IGNORED = "GUIDELINE_IGNORED",
  OTHER = "OTHER",
}

export enum BillingsOrderRailyTaxiCreateRequestBonusType {
  DISTANCE_RATE_CHANGED = "DISTANCE_RATE_CHANGED",
  HALTING_RATE_CHANGED = "HALTING_RATE_CHANGED",
  SHORT_ROUTE = "SHORT_ROUTE",
  OTHER = "OTHER",
}

export type BillingsOrderRailyTaxiCreateRequestBody = {
  billingNodes: BillingsOrderRailyTaxiCreateRequestBillingNode[];
  bonus: number;
  penalty: number;
  penaltyType?: BillingsOrderRailyTaxiCreateRequestPenaltyType;
  bonusType?: BillingsOrderRailyTaxiCreateRequestBonusType;
};

type BillingsOrderRailyTaxiCreateRequest = {
  orderUuid: string;
  billingNodes: BillingsOrderRailyTaxiCreateRequestBillingNode[];
  bonus: number;
  penalty: number;
  penaltyType?: BillingsOrderRailyTaxiCreateRequestPenaltyType;
  bonusType?: BillingsOrderRailyTaxiCreateRequestBonusType;
};

export default BillingsOrderRailyTaxiCreateRequest;
